export default {
  message: {
    "error": "Terjadi kesalahan!",
    "Sorrysomeerrorsoccurred": "Maaf, terjadi beberapa kesalahan",
    "quit": "Keluar",
    "language": "Bahasa",
    "Youcanchangethelanguagehere": "Anda dapat mengubah bahasa di sini!",
    "current": "Saat ini",
    "home": "Beranda",
    "friends": "Teman",
    "wallet": "Kantung",
    "aboutus": "Tentang Kami",
    "Sharewithfriends": "Bagikan dengan teman",
    "copyFailure": "Salin Gagal",
    "copySuccess": "Salin Berhasil",
    "Claimreward": "Kumpulkan hadiah",
    "DailyLogin": "Masuk Harian",
    "noInvitationsYet": "Belum ada Undangan",
    "LoadMore": "Muatan Lagi",
    "WatchAD": "Tonton Iklan",
    "continue": "Lanjutkan",
    "Congratulations": "Selamat",
    "MyFriends": "Teman-Temanku",
    "Invitefriends": "Undang teman",
    "Invitepremiumfriends": "Undang teman premium",
    "DailyTasks": "Tugas harian",
    "inviteDesc": "+{num} ${name} untuk setiap teman yang Anda undang",
    "DailyTasksDesc": "Selesaikan tugas untuk mendapatkan lebih banyak ${name}",
    "SponsorsandPartners": "Sponsor dan Mitra",
    "Receivingwallet": "Mengambil dompet",
    "Enterwalletaddress": "Masukkan alamat dompet {name}",
    "Claim": "Kumpulkan",
    "Booster": "Pendorong",
    "RentPeriod": "Periode Sewa",
    "days30": "30 hari",
    "days": "hari",
    "Dailyprofit": "Keuntungan harian",
    "Totalprofit": "Total keuntungan",
    "Quantity": "Kuantitas",
    "RentPrice": "Harga Sewa",
    "RentMiner": "Sewa Penambang",
    "Insufficient": "{name} tidak cukup",
    "InsufficientMsg": "{num} ${name1} diperlukan, undang teman atau selesaikan tugas untuk mendapatkan lebih banyak ${name2}.",
    "Settings": "Pengaturan",
    "copyid": "Salin ID",
    "UpgradeSuccessfully": "Pembaruan Berhasil",
    "Name": "Nama",
    "userinfo": "Info Pengguna",
    "disconnect": "Putuskan sambungan",
    "Startmining": "Mulai menambang",
    "Welcome": "Selamat datang di {name}",
    "Withdrawal": "Penarikan",
    "Minimumamount": "Jumlah minimum",
    "Networkfee": "Biaya jaringan",
    "Enteramount": "Masukkan jumlah",
    "Submit": "Kirim",
    "MinimumTip": "Jumlah penarikan terlalu kecil. Jumlah penarikan minimum: {num}",
    "MaximumTip": "Jumlah tidak mencukupi, jumlah maksimum yang dapat Anda tarik adalah: {num}",
    "SubmittedTip": "Dikirim, diharapkan diproses dalam waktu 30-60 hari kerja",
    "WithdrawStatus": "Status",
    "Submissiontime": "Waktu pengajuan",
    "WithdrawAwaitTip": "* Diperkirakan memakan waktu 30-60 hari kerja. Mengundang lebih banyak teman dapat mempercepat proses peninjauan.",
    "Processing": "Dalam proses",
    "Amount": "Jumlah",
    "Numberoffriends": "Jumlah teman: {now}/{limit}",
    "InviteTip": "Untuk melakukan penarikan pertama Anda, Anda perlu mengundang {limit} teman untuk bergabung dengan aplikasi mining.",
    "openonphone": "Buka tautan ini di ponsel Anda.",
    "claimTip": "Jumlah yang akan diterima terlalu kecil. Jumlah minimum yang dapat diterima adalah: {num}",
    "WalletBalance": "Saldo Dompet",
    "Withdraw": "Tarik",
    "SetWalletAddress": "Atur Alamat Dompet",
    "WithdrawalRecord": "Rekam Penarikan",
    "Norecords": "Tidak ada catatan",
    "Whatis": "Apa itu {name}?",
    "All": "Semua",
    "save": "Simpan",
    "successWithdrawal": "Penarikan telah diterima {num}",
    "secondsago": "{time} detik yang lalu",
    "Loading": "Memuat...",
    "PaymentConfirming": "Memeriksa Status Transaksi...",
    "Check": "Periksa",
    "CheckFail": "Transaksi tidak selesai. Silakan periksa lagi dalam 5 detik.",
    "Addname": "Tambahkan '{name}' ke nama Anda",
    "Restattcheck": "Mulai ulang aplikasi untuk memeriksa",
    "Copyname": "Salin '{name}'",
    "SubmissionFailed": "Pengajuan gagal, silakan coba lagi nanti",
    "WithdrawalReview": "Ulasan penarikan",
    "WebWithdrawAwaitTip": "* Diperkirakan memakan waktu 24-48 jam. Mengundang lebih banyak teman dapat mempercepat proses peninjauan.",
    "Success": "Berhasil",
    "Rejection": "Ditolak",
    "WebSubmittedTip": "Dikirim, diharapkan diproses dalam waktu 24-48 jam",
    "shop": "Toko",
    "topurchase": "Masuk ke toko untuk membeli",
    "shopDesc": "Ketersediaan terbatas—dapatkan milik Anda sebelum lenyap!",
    "claim": "Kumpulkan",
    "payment_success": "Pembayaran berhasil",
    "payment_failed": "Pembayaran gagal",
    "payment_cancelled": "Pembayaran dibatalkan",
    "opening_payment": "Membuka pembayaran...",
    "payment_status": "Status pembayaran",
    "create_order_failed": "Gagal membuat pesanan",
    "creating_ton_order": "Membuat pesanan TON...",
    "next_step": "Langkah selanjutnya",
    "use_ton_payment": "Gunakan pembayaran TON",
    "start_transaction": "Mulai transaksi",
    "connect_wallet": "Hubungkan dompet",
    "address": "Alamat",
    "amount_ton": "Jumlah TON",
    "copy": "Salin",
    "amount": "Jumlah",
    "wallet_address": "Alamat dompet",
    "comment_memo": "Komentar memo",
    "you_can_choose_to_connect_wallet_to_pay": "Anda dapat memilih untuk menghubungkan dompet untuk membayar",
    "or_manually_transfer_to_the_above_address": "Atau mentransfer secara manual ke alamat di atas (perhatikan bahwa jumlah dan memo harus persis sama)",
    "transaction_success": "Transaksi berhasil",
    "transaction_failed": "Transaksi gagal",
    "transaction_error": "Kesalahan transaksi",
    "transaction_status": "Status transaksi",
    "transaction_id": "ID transaksi",
    "transaction_amount": "Jumlah transaksi",
    "transaction_status_desc": "Deskripsi status transaksi",
    "payment_status_tip": "Silakan tunggu konfirmasi pembayaran",
    "select_payment_method": "Pilih metode pembayaran",
    "total_amount": "Total jumlah",
    "creating_order": "Membuat pesanan...",
    "order_created": "Pesanan dibuat",
    "order_status": "Status pesanan",
    "Applyforwithdrawal": "Ajukan penarikan",
    "Withdrawalunlock": "Membuka penarikan",
    "WithdrawalunlockTip": "Anda perlu {num} teman yang diundang untuk menyelesaikan tugas/mengikat dompet untuk membuka kunci penarikan",
    "Close": "Tutup",
    "Delivering": "Dalam pengiriman",
    "Duetothelargenumber": "Karena jumlah penerima yang besar, airdrop Anda diharapkan tiba dalam 15-20 hari kerja",
    "select_network": "Pilih jaringan",
    "confirm": "konfirmasi",
    "switching_network": "Berpindah jaringan...",
    "network_switched": "Jaringan telah berpindah",
    "use_usdt_payment": "Gunakan pembayaran USDT",
    "or_manually_transfer_to_the_above_address_usdt": "Transfer manual ke alamat di atas (perhatikan bahwa jumlah dan alamat harus persis sama)",
    "chain_type": "Jaringan",
    "check_transaction_status": "Periksa status transaksi",
    "transaction_wait": "Transaksi sedang diproses. Anda dapat keluar dari aplikasi. Sebuah pesan akan memberi tahu Anda setelah selesai.",
    "twa_pay_tip_with_memo": "Silakan pastikan alamat, jumlah, dan memo konsisten untuk transfer.",
    "twa_pay_tip": "Silakan pastikan alamat dan jumlah benar untuk transfer.",
    "creating_usdt_order": "Membuat pesanan USDT...",
    "affiliate_programs": "Program afiliasi",
    "affiliate_programs_description": "Undang teman untuk bergabung dengan aplikasi penambangan dan dapatkan hadiah.",
    "commission_details": "Detail komisi",
    "no_commission_records": "Tidak ada catatan komisi",
    "commission_list": "Daftar komisi",
    "input_amount": "Masukkan jumlah",
    "max": "Maks",
    "commission_input_amount": "Masukkan jumlah komisi",
    "min_commission": "Jumlah penarikan minimum adalah {num}",
    "WithdrawalSuccess": "Pinarikan berhasil",
    "WithdrawalFailed": "Pinarikan gagal",
    "WithdrawalProcessing": "Penarikan sedang diproses",
    "award": "Penghargaan",
    "level": "Tingkat",
    "Share_to_group": "Bagikan ke grup",
    "Exchange": "Pertukaran",
    "balance_not_enough": "Saldo tidak cukup, Anda hanya dapat menukarkan {num} {coin}",
    "exchange_fail": "Pertukaran gagal",
    "exchange_success": "Pertukaran berhasil",
    "you_will_receive": "Anda akan menerima",
    "ShareToGroups": "Bagikan ke grup",
    "Numberofgroups": "Jumlah grup: {now}/{limit}",
    "Confirm": "Konfirmasi",
    "ShareToGroupsDesc": "Bagikan ke grup untuk mendapatkan lebih banyak {name}",
    "TokenAddress": "Silakan masukkan detail penarikan seperti ID pertukaran atau alamat USDT",
    "CashAddress": "Silakan masukkan detail penarikan seperti nomor kartu bank atau alamat USDT",
    "Cancel": "Batal",
    "min_withdrawal_amount": "Jumlah penarikan minimum adalah {num} {coin}",
    "max_withdrawal_amount": "Jumlah penarikan maksimum adalah {num} {coin}",
    "withdrawal_failed": "Penarikan gagal",
    "withdrawal_success": "Penarikan berhasil",
    "PayNow": "Bayar sekarang",
    "PaySkip": "Bayar {num} untuk segera membuka penarikan",
    "NumberofGroups": "Jumlah grup: {now}/{limit}",
    "SendMessage": "Kirim pesan",
    "NumberofShares": "Jumlah pembagian: {now}/{limit}",
    "NumberofTasks": "Jumlah tugas: {now}/{limit}",
    "CompleteTask": "Selesaikan tugas",
    "PleaseEnterValidAmount": "Silakan Masukkan Jumlah yang Valid",
    "PleaseEnterValidEmail": "Silakan Masukkan Email yang Valid",
    "Feedback": "Umpan Balik",
    "Inputfeedbackcontent": "Masukkan konten umpan balik",
    "Submitfeedback": "Kirim umpan balik",
    "Pleaseenteravalidemailaddress": "Silakan masukkan alamat email yang valid",
    "Pleaseenteryouremailaddress": "Silakan masukkan alamat email Anda",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "Anda sudah memberikan umpan balik hari ini, silakan kembali besok",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "Umpan balik berhasil dikirim, terima kasih atas umpan balik Anda yang berharga",
    "Feedback_submission_failed_please_retry": "Pengiriman umpan balik gagal, silakan coba lagi",
    "ContactUs": "Hubungi Kami",
    "XRPAddress": "Silakan isi alamat dompet rantai XRP yang diaktifkan (termasuk MEMO), jika tidak, Anda tidak akan dapat menarik uang tunai.",
    "Accelerated": "Dipercepat",
    "Accelerated_withdrawals_success": "Penarikan yang dipercepat berhasil",
    "login": "Masuk",
    "register": "Daftar",
    "login_with_google": "Masuk dengan Google",
    "or": "ATAU",
    "email": "Email",
    "password": "Kata Sandi",
    "no_account": "Belum memiliki akun",
    "click_to_go": "Klik untuk",
    "have_account": "Sudah memiliki akun",
    "go_to": "Ke",
    "invite_code": "Kode Undangan",
    "optional": "Opsional",
    "google_login_not_ready": "Masuk Google belum siap, silakan coba lagi nanti",
    "password_too_long": "Kata sandi terlalu panjang",
    "weak": "Lemah",
    "medium": "Sedang",
    "strong": "Kuat",
    "login_success": "Masuk berhasil",
    "login_failed": "Masuk gagal",
    "please_input_email": "Silakan masukkan email Anda",
    "invalid_email": "Format email tidak valid",
    "please_input_password": "Silakan masukkan kata sandi Anda",
    "password_length_6_to_16": "Kata sandi harus 6-16 karakter",
    "account_or_password_error": "Kesalahan akun atau kata sandi",
    "register_success": "Registrasi berhasil",
    "register_failed": "Registrasi gagal",
    "save_error": "Kesalahan penyimpanan, silakan coba lagi nanti",
    "ShareToFriends": "Bagikan kepada teman-teman",
    "login_first": "Silakan masuk terlebih dahulu",
    "WalletBscError": "❌ Alamat dompet BNB Chain tidak valid.",
    "DownloadWallet": "Unduh Dompet",
    "AddToHomeScreen": "Tambahkan {appName} ke layar beranda",
    "TapShareInToolbar": "Ketuk di bilah alat",
    "SelectAddToHomeScreen": "Pilih tambahkan ke layar beranda",
    "OpenToolbar": "Buka Bilah Alat",
    "ClaimFailed": "Penerimaan gagal, silakan coba lagi nanti",
    "guest_login": "Masuk Tamu",
    "please_input_phone": "Silakan masukkan nomor ponsel Anda",
    "email_error_1": "Silakan masukkan email Anda",
    "email_error_2": "Silakan masukkan alamat email yang valid",
    "email_error_3": "Email tamu tidak diizinkan, silakan gunakan email yang nyata",
    "phone": "Ponsel",
    "phone_error_1": "Silakan masukkan nomor ponsel Anda",
    "phone_error_2": "Silakan masukkan nomor ponsel yang valid",
    "update_info": "Perbarui Informasi",
    "update_success": "Perbarui berhasil",
    "update_failed": "Perbarui gagal, silakan coba lagi nanti",
    "cancel": "Batalkan",
    "guest_credentials_title": "Informasi Akun",
    "guest_credentials_warning": "Silakan ambil tangkapan layar untuk menyimpan akun dan kata sandi Anda. Jika hilang, penghasilan Anda tidak dapat dipulihkan!",
    "i_have_saved": "Saya telah menyimpan",
    "account": "Akun",
    "view_credentials": "Lihat Kredensial",
    "miner_max_reached": "Anda telah mencapai jumlah maksimum dari penambang ini"
}};